import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import SummaryHeader from "components/header/SummaryHeader";
import SummaryItem from "components/header/SummaryItem";
import { Inbox, Mail, MailOpen, Star } from "lucide-react";
import InboxTab from "./components/InboxTab";
import {
    getTicketList 
} from "../../../../../redux/ticket/ticketState";


const ClientInbox = ({
  doSearch,
  pagination,
  recordList = [],
}) => {
  const [starredMessages, setStarredMessages] = useState({});

  useEffect(() => {
    doSearch({
      paginate: pagination?.per_page || 10,
    });
  }, [doSearch, pagination?.per_page]);

  const toggleStar = (id) => {
    setStarredMessages((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const totalCount = recordList?.length || 0;
  const unreadCount = recordList?.filter((ticket) => ticket.tic_is_seen !== 1).length || 0;
  const starredCount = Object.values(starredMessages).filter(Boolean).length;

  return (
    <div className="space-y-6">
      <SummaryHeader
        title="Communications Center"
        icon={Inbox}
        color="blue-purple"
        description="Announcements and updates from Hyvid"
      >
        <div className="summary-item-container">
          <SummaryItem
            title="Total Messages"
            icon={<Mail className="w-4 h-4" />}
            display={totalCount}
          />
          <SummaryItem
            title="Unread"
            icon={<MailOpen className="w-4 h-4" />}
            display={unreadCount}
          />
          <SummaryItem
            title="Starred"
            icon={<Star className="w-4 h-4" />}
            display={starredCount}
          />
        </div>
      </SummaryHeader>

      <InboxTab
        messages={recordList}              
        starredMessages={starredMessages}  
        toggleStar={toggleStar}
        onSelectMessage={() => {}}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  recordList: state.ticket.ticketList?.items,
  pagination: state.ticket.ticketList?.pagination,
  filters: state.ticket.ticketList?.filters,
});

const mapDispatchToProps = (dispatch) => ({
  doSearch: (filters) => dispatch(getTicketList(filters)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ClientInbox);